<template>
  <div class="block-wrap block-specification">
    <div class="add-sku-tips">
      <div>如需添加新的规格值,请至<el-link @click="changeToBase">【基础资料】</el-link>进行添加</div>
      <span @click="handleNoTips" class="tips-btn">不再提示</span>
    </div>
    <template v-for="(s, sindex) in specifications">
      <div :key="sindex" v-if="s.nameKey">
        <el-form class="title-bg" ref="skuForm" :model="s" :rules="skuRules" inline>
          规格名：
          <el-form-item prop="name">
            <el-select v-model="s.name" placeholder="请选择" width="200px" @change="val => changeSelectSpecName(val, sindex)">
              <el-option v-for="(item, sindex) in variations" :key="item.name + sindex" :label="item.name" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="specification-value">
          <div style="display: inline-block; padding-top: 7px; padding-left: 10px">规格值：</div>
          <vue-draggable
            class="specification-value-flex"
            v-model="s.values"
            :group="{ pull: 'clone', put: false }"
            handle=".drag-icon-wrap"
            :animation="500"
          >
            <div v-for="(v, vi) in s.values" :key="v.valueKey + vi" class="specification-value-flex_item">
              <el-form ref="specValueForm" :model="v">
                <el-form-item :rules="genFormValueItemRule(v.value, vi, s.values)" prop="value">
                  <div class="del-input-wrap">
                    <el-select
                      class="specification-value-flex_input"
                      v-model="v.value"
                      @change="handleSelect(v, s)"
                      @visible-change="visibleChangeSelect(s)"
                      placeholder="请输入或选择"
                      width="200px"
                      filterable
                      allow-create
                      blur-create
                      clearable
                      default-first-option
                    >
                      <el-option
                        v-for="item in attributeOptions[s.nameKey]"
                        :key="item.valueId"
                        :label="item.valueName"
                        :value="item.valueName"
                      >
                      </el-option>
                    </el-select>
                    <el-checkbox style="margin-left: 8px" v-model="v.checked" @change="onChangeCheckbox"> </el-checkbox>
                    <drag-item-content></drag-item-content>
                  </div>
                </el-form-item>
                <el-form-item v-if="sindex === 0" prop="imageUrl" :rules="genFormItemImgRule(v, s, `${sindex}-${vi}-img`)">
                  <div class="specification-value-flex_img">
                    <ImgUpload
                      :ref="`${sindex}-${vi}-img`"
                      :file="v.imageUrl"
                      v-model="v.imageUrl"
                      :width="80"
                      :height="80"
                      :size="150"
                      :limitSize="autoCropImageConfigList.includes('skuImg') ? 0 : 1024 * 1024 * 3"
                      :aspectRatio="autoCropImageConfigList.includes('skuImg') ? 0 : [1,0.75]"
                      aspectRatioText="1:1或3:4"
                      :aspectRatioLimitWidth="[
                        [800, 0],
                        [750, 0],
                      ]"
                      limitSuffix=".jpg,.jpeg,.png"
                      :isSingle="true"
                      :isPureType="isPureType"
                      :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                      @upload-success="url => imageUploadSuccess(url, v)"
                      @del="() => imageUploadDel(v)"
                    />
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </vue-draggable>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import { attributeValues } from '@/servers/prod/center/xhs.js';
import { dragItemMixin } from '../../utils/mixins';
import utils from '@/utils';

export default {
  components: {
    ImgUpload,
  },
  model: {
    prop: 'values',
    event: 'change',
  },
  mixins: [dragItemMixin],
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    variations: {
      type: Array,
      default() {
        return [];
      },
    },
    changeToBase: {
      // 打开基础资料编辑
      type: Function,
      default: () => {},
    },
    autoCropImageConfigList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isPureType: false,
      specifications: [],
      specNameList: [],
      attributeOptions: {},
      attributeOptionLoadeds: {},
    };
  },

  watch: {
    values: {
      async handler(v) {
        if (!v?.length) return;
        await Promise.all(v.map(async spec => {
          await this.getAttributeOptions(spec.nameKey);
          const options = this.attributeOptions[spec.nameKey] || [];
          // 处理规格值
          spec.values.forEach(valueItem => {
            const matchedOption = options.find(op => op.valueName === valueItem.value);
            if (matchedOption) {
              valueItem.propValueId = matchedOption.valueId;
            }
          });
        }));
        this.specifications = v;
        this.specNameList = v.map(item => {
          return { name: item.name, nameKey: item.nameKey };
        });
        this.$nextTick(() => {
          this.validateSpecValueForm()
        })
      },
      immediate: true,
    },
  },
  computed: {
    skuRules() {
      return {
        name: [
          { required: true, validator: (_, value, callback) => {
            if (!this.variations.find(s => s.name === value)) {
              return callback(new Error('规格名不存在，重新选择'))
            } 
            return callback();
          }, trigger: 'change' }
        ],
      };
    }
  },
  methods: {
    isSame(values, value, idx) {
      let flag = false;
      values.forEach((item, i) => {
        if (i !== idx && item.value === value) {
          flag = true;
        }
      });
      return flag;
    },
    genFormValueItemRule(value, vi, sValues) {
      let valueValidator = (rule, val, callback) => {
        if (!value) {
          return callback(new Error('请填写规格值'));
        }
        if (this.checkLength(value) > 60) {
          return callback(new Error('规格值不能超过30个字（60个字符）'));
        }

        if (this.isSame(sValues, value, vi)) {
          return callback(new Error('请勿选择相同规格值'));
        }
        callback();
      };
      return [{ required: true, validator: valueValidator, trigger: 'change' }];
    },
    genFormItemImgRule(valueItem, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        const refImg = this.$refs[ref]
        if (valueItem.imageUrl && refImg && refImg[0]) {
          let errMsg = await refImg[0].method_validImage()
          if(errMsg) {
            return callback(new Error(errMsg))
          } else {
            callback();
          }
        }
        callback();
      }
      return [
        {
          required: true,
          validator: valueValidator
        }
      ];
    },
    validateSpecValueForm() {
      const valueForms = this.$refs.specValueForm;
      const skuForms = this.$refs.skuForm || [];
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
        }
        const promiseList = valueForms.concat(Array.isArray(skuForms) ? skuForms : [skuForms]).map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        });
        Promise.all(promiseList)
          .then(results => {
            resolve(results.every(Boolean));
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    handleSelect(v, s) {
      if (this.attributeOptions[s.nameKey]) {
        const findItem = this.attributeOptions[s.nameKey].find(item => item.valueName == v.value) || {};
        v.propValueId = findItem.valueId || '';
      }
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
    },
    handleNoTips() {
      this.showAddSkuTips = false;
      localStorage.setItem('noSecTips', 1);
    },
    changeSelectSpecName(val, sindex) {
      const findItem = this.variations.find(item => item.name === val);
      if (findItem) {
        this.specifications[sindex].nameKey = findItem.id;
      }
      const sameIndex = this.specNameList.findIndex(s => s.name === val);
      if (sameIndex > -1 && sameIndex !== sindex) {
        this.specifications[sameIndex].name = this.specNameList[sindex].name;
        this.specifications[sameIndex].nameKey = this.specNameList[sindex].nameKey;
      }
      this.specNameList = this.specifications.map(item => {
        return { name: item.name, nameKey: item.nameKey };
      });
    },
    visibleChangeSelect(s) {
      this.getAttributeOptions(s.nameKey)
    },
    imageUploadSuccess(url, v) {
      v.imageUrl = url;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v) {
      v.imageUrl = '';
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    onChangeCheckbox() {
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      window.__spcificationCheckbox_changed = true;
    },
    async getAttributeOptions(nameKey) {
      if (!nameKey || this.attributeOptionLoadeds[nameKey] || !this.variations.find(s => s.id === nameKey)) return;
      let params = {
        shopId: this.$store.getters.shops_getCategoryPropShopId('xhs'),
        attributeId: nameKey,
      };
      const res = await attributeValues(params)
      if(res?.data?.attributeValueV3s) {
        let attributeValueV3s = res.data.attributeValueV3s || [];
        this.$set(this.attributeOptions, nameKey, attributeValueV3s);
        this.$set(this.attributeOptionLoadeds, nameKey, true);
      }
    },
    /**
     * 检测长度
     * @param {*} strTemp
     * @returns
     */
    checkLength(strTemp) {
      let length = 0;

      if (strTemp) {
        const strGbk = utils.gbk.encode(strTemp);

        length = strGbk.length;
      }

      return length;
    },
  },
};
</script>

<style lang="scss" scoped>
.block-wrap {
  .specification-value-flex {
    position: relative;
    top: -16px;
  }
  border: 1px solid #dcdfe6;
  padding: 10px;
  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
  }
  .tips-btn {
    cursor: pointer;
  }
}

.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
}

.specification-value {
  ::v-deep .el-form-item__error {
    position: unset !important;
  }
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    &_item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    &_img {
      width: 82px;
      height: 82px;
      margin-top: 10px;
      position: relative;
    }
    .el-input {
      width: 160px;
    }
  }
}

.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
</style>